import styled, { css } from "styled-components";

import "../../../../../../../GlobalStyles/Font.css";

export const ContainerCalender = styled.div`
  position: "relative";
  width: 60px;

  @media (min-width: 1024px) {
    width: 90px;
  }
`;

export const InputDateContainer = styled.input`
  width: 60px;
  font-size: 16px;
  font-family: "Exo2 Light";
  font-weight: 500;

  @media (min-width: 1024px) {
    font-size: 24px;
    width: 90px;
  }
`;

export const Frame = styled.div`
  width: 280px;
  border: 1px solid lightgrey;
  box-shadow: 2px 2px 2px #eee;
`;

export const Header = styled.div`
  width: 260px;
  font-size: 18px;
  font-weight: bold;
  padding: 10px 10px 5px 10px;
  display: flex;
  justify-content: space-between;
  background-color: #f5f6fa;
`;

export const Button = styled.div`
  cursor: pointer;
`;

export const Body = styled.div`
  width: 319px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const Day = styled.div<{
  $isToday?: boolean;
  $isSelected?: boolean;
  $isDisabled?: boolean;
}>`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${(props) =>
    props.$isToday &&
    css`
      border: 1px solid #eee;
      color: #000;
    `}

  ${(props) =>
    props.$isSelected &&
    css`
      background-color: #eee;
    `}

  ${(props) =>
    props.$isDisabled &&
    css`
      color: #ccc;
      cursor: not-allowed;
    `}
`;
